import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';
import { SelectOption } from '../../shared/models/dropdowm.model';
import {
  DisplayAreaType,
  UpdateDisplayArea,
} from '../models/display-area.model';

@Injectable({
  providedIn: 'root',
})
export class DisplayAreaService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(pageNumber: number, pageSize: number, name?: string, slug?: string) {
    let params = '';

    if (name) params += `&name=${name}`;
    if (slug) params += `&slug=${slug}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/display-areas?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(
      this.apiBaseUrl + '/api/v1/display-areas/' + id
    );
  }

  update(id: string, data: UpdateDisplayArea) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/display-areas/' + id,
      data
    );
  }

  getDisplayAreaTypeOptions(): SelectOption[] {
    return [
      { label: 'Produto', value: DisplayAreaType.Product },
      { label: 'Modelo', value: DisplayAreaType.Model },
      { label: 'Versão do Modelo', value: DisplayAreaType.ModelVersion },
      { label: 'Categoria', value: DisplayAreaType.Category },
      { label: 'Marca', value: DisplayAreaType.Brand },
    ];
  }
}
